export const TAROT_DECK = Object.freeze([
  {
    "id": "major-00-the-fool",
    "name": "The Fool",
    "group": "major",
    "asset": "tarot-major-00-the-fool.webp",
    "upright": [
      "new beginning",
      "openness",
      "trusted step"
    ],
    "reversed": [
      "recklessness",
      "hesitation",
      "unprepared step"
    ]
  },
  {
    "id": "major-01-the-magician",
    "name": "The Magician",
    "group": "major",
    "asset": "tarot-major-01-the-magician.webp",
    "upright": [
      "agency",
      "skill",
      "focused action"
    ],
    "reversed": [
      "misdirection",
      "unused ability",
      "scattered action"
    ]
  },
  {
    "id": "major-02-the-high-priestess",
    "name": "The High Priestess",
    "group": "major",
    "asset": "tarot-major-02-the-high-priestess.webp",
    "upright": [
      "intuition",
      "inner knowing",
      "quiet observation"
    ],
    "reversed": [
      "ignored intuition",
      "hidden tension",
      "inner noise"
    ]
  },
  {
    "id": "major-03-the-empress",
    "name": "The Empress",
    "group": "major",
    "asset": "tarot-major-03-the-empress.webp",
    "upright": [
      "care",
      "growth",
      "receptivity"
    ],
    "reversed": [
      "overgiving",
      "creative block",
      "neglected needs"
    ]
  },
  {
    "id": "major-04-the-emperor",
    "name": "The Emperor",
    "group": "major",
    "asset": "tarot-major-04-the-emperor.webp",
    "upright": [
      "structure",
      "authority",
      "clear boundary"
    ],
    "reversed": [
      "rigidity",
      "control",
      "unstable structure"
    ]
  },
  {
    "id": "major-05-the-hierophant",
    "name": "The Hierophant",
    "group": "major",
    "asset": "tarot-major-05-the-hierophant.webp",
    "upright": [
      "tradition",
      "shared values",
      "guidance"
    ],
    "reversed": [
      "questioned convention",
      "personal belief",
      "misaligned values"
    ]
  },
  {
    "id": "major-06-the-lovers",
    "name": "The Lovers",
    "group": "major",
    "asset": "tarot-major-06-the-lovers.webp",
    "upright": [
      "connection",
      "alignment",
      "meaningful choice"
    ],
    "reversed": [
      "misalignment",
      "conflicted values",
      "relationship strain"
    ]
  },
  {
    "id": "major-07-the-chariot",
    "name": "The Chariot",
    "group": "major",
    "asset": "tarot-major-07-the-chariot.webp",
    "upright": [
      "direction",
      "determination",
      "self-command"
    ],
    "reversed": [
      "forced progress",
      "loss of direction",
      "competing impulses"
    ]
  },
  {
    "id": "major-08-strength",
    "name": "Strength",
    "group": "major",
    "asset": "tarot-major-08-strength.webp",
    "upright": [
      "courage",
      "patience",
      "gentle influence"
    ],
    "reversed": [
      "self-doubt",
      "reactivity",
      "drained confidence"
    ]
  },
  {
    "id": "major-09-the-hermit",
    "name": "The Hermit",
    "group": "major",
    "asset": "tarot-major-09-the-hermit.webp",
    "upright": [
      "reflection",
      "discernment",
      "inner search"
    ],
    "reversed": [
      "isolation",
      "avoidance",
      "refused insight"
    ]
  },
  {
    "id": "major-10-wheel-of-fortune",
    "name": "Wheel of Fortune",
    "group": "major",
    "asset": "tarot-major-10-wheel-of-fortune.webp",
    "upright": [
      "turning point",
      "cycle",
      "changing conditions"
    ],
    "reversed": [
      "resistance to change",
      "repeating cycle",
      "poor timing"
    ]
  },
  {
    "id": "major-11-justice",
    "name": "Justice",
    "group": "major",
    "asset": "tarot-major-11-justice.webp",
    "upright": [
      "truth",
      "accountability",
      "fair decision"
    ],
    "reversed": [
      "bias",
      "avoidance",
      "unequal consequence"
    ]
  },
  {
    "id": "major-12-the-hanged-man",
    "name": "The Hanged Man",
    "group": "major",
    "asset": "tarot-major-12-the-hanged-man.webp",
    "upright": [
      "pause",
      "new perspective",
      "surrender"
    ],
    "reversed": [
      "stagnation",
      "delay",
      "refused perspective"
    ]
  },
  {
    "id": "major-13-death",
    "name": "Death",
    "group": "major",
    "asset": "tarot-major-13-death.webp",
    "upright": [
      "ending",
      "release",
      "transformation"
    ],
    "reversed": [
      "resistance",
      "unfinished ending",
      "fear of change"
    ]
  },
  {
    "id": "major-14-temperance",
    "name": "Temperance",
    "group": "major",
    "asset": "tarot-major-14-temperance.webp",
    "upright": [
      "balance",
      "integration",
      "measured progress"
    ],
    "reversed": [
      "excess",
      "imbalance",
      "poor integration"
    ]
  },
  {
    "id": "major-15-the-devil",
    "name": "The Devil",
    "group": "major",
    "asset": "tarot-major-15-the-devil.webp",
    "upright": [
      "attachment",
      "temptation",
      "revealed pattern"
    ],
    "reversed": [
      "release",
      "reclaimed choice",
      "loosening attachment"
    ]
  },
  {
    "id": "major-16-the-tower",
    "name": "The Tower",
    "group": "major",
    "asset": "tarot-major-16-the-tower.webp",
    "upright": [
      "disruption",
      "revelation",
      "necessary change"
    ],
    "reversed": [
      "avoided upheaval",
      "private disruption",
      "delayed truth"
    ]
  },
  {
    "id": "major-17-the-star",
    "name": "The Star",
    "group": "major",
    "asset": "tarot-major-17-the-star.webp",
    "upright": [
      "hope",
      "healing",
      "renewed trust"
    ],
    "reversed": [
      "discouragement",
      "depletion",
      "difficulty receiving hope"
    ]
  },
  {
    "id": "major-18-the-moon",
    "name": "The Moon",
    "group": "major",
    "asset": "tarot-major-18-the-moon.webp",
    "upright": [
      "uncertainty",
      "subconscious pattern",
      "partial information"
    ],
    "reversed": [
      "emerging clarity",
      "named fear",
      "reduced confusion"
    ]
  },
  {
    "id": "major-19-the-sun",
    "name": "The Sun",
    "group": "major",
    "asset": "tarot-major-19-the-sun.webp",
    "upright": [
      "clarity",
      "vitality",
      "open success"
    ],
    "reversed": [
      "delayed joy",
      "overexposure",
      "temporary doubt"
    ]
  },
  {
    "id": "major-20-judgement",
    "name": "Judgement",
    "group": "major",
    "asset": "tarot-major-20-judgement.webp",
    "upright": [
      "awakening",
      "review",
      "decisive call"
    ],
    "reversed": [
      "self-judgement",
      "avoided call",
      "unfinished review"
    ]
  },
  {
    "id": "major-21-the-world",
    "name": "The World",
    "group": "major",
    "asset": "tarot-major-21-the-world.webp",
    "upright": [
      "completion",
      "integration",
      "wider perspective"
    ],
    "reversed": [
      "unfinished cycle",
      "missing closure",
      "narrowed perspective"
    ]
  },
  {
    "id": "wands-01-ace",
    "name": "Ace of Wands",
    "group": "wands",
    "asset": "tarot-wands-01-ace.webp",
    "upright": [
      "energy",
      "initiative",
      "new opening",
      "potential"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "blocked start",
      "missed opening"
    ]
  },
  {
    "id": "wands-02-two",
    "name": "Two of Wands",
    "group": "wands",
    "asset": "tarot-wands-02-two.webp",
    "upright": [
      "energy",
      "initiative",
      "choice",
      "balance"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "indecision",
      "imbalance"
    ]
  },
  {
    "id": "wands-03-three",
    "name": "Three of Wands",
    "group": "wands",
    "asset": "tarot-wands-03-three.webp",
    "upright": [
      "energy",
      "initiative",
      "growth",
      "collaboration"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "misalignment",
      "tension"
    ]
  },
  {
    "id": "wands-04-four",
    "name": "Four of Wands",
    "group": "wands",
    "asset": "tarot-wands-04-four.webp",
    "upright": [
      "energy",
      "initiative",
      "structure",
      "consolidation"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "stagnation",
      "rigidity"
    ]
  },
  {
    "id": "wands-05-five",
    "name": "Five of Wands",
    "group": "wands",
    "asset": "tarot-wands-05-five.webp",
    "upright": [
      "energy",
      "initiative",
      "challenge",
      "necessary change"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "recovery",
      "lingering strain"
    ]
  },
  {
    "id": "wands-06-six",
    "name": "Six of Wands",
    "group": "wands",
    "asset": "tarot-wands-06-six.webp",
    "upright": [
      "energy",
      "initiative",
      "support",
      "adjustment"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "unequal exchange",
      "unresolved past"
    ]
  },
  {
    "id": "wands-07-seven",
    "name": "Seven of Wands",
    "group": "wands",
    "asset": "tarot-wands-07-seven.webp",
    "upright": [
      "energy",
      "initiative",
      "assessment",
      "strategy"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "doubt",
      "unhelpful shortcut"
    ]
  },
  {
    "id": "wands-08-eight",
    "name": "Eight of Wands",
    "group": "wands",
    "asset": "tarot-wands-08-eight.webp",
    "upright": [
      "energy",
      "initiative",
      "movement",
      "developing mastery"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "restriction",
      "delay"
    ]
  },
  {
    "id": "wands-09-nine",
    "name": "Nine of Wands",
    "group": "wands",
    "asset": "tarot-wands-09-nine.webp",
    "upright": [
      "energy",
      "initiative",
      "attainment",
      "inner state"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "anxiety",
      "isolation"
    ]
  },
  {
    "id": "wands-10-ten",
    "name": "Ten of Wands",
    "group": "wands",
    "asset": "tarot-wands-10-ten.webp",
    "upright": [
      "energy",
      "initiative",
      "completion",
      "consequence"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "burden",
      "unfinished cycle"
    ]
  },
  {
    "id": "wands-11-page",
    "name": "Page of Wands",
    "group": "wands",
    "asset": "tarot-wands-11-page.webp",
    "upright": [
      "energy",
      "initiative",
      "curiosity",
      "new message"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "immaturity",
      "mixed signal"
    ]
  },
  {
    "id": "wands-12-knight",
    "name": "Knight of Wands",
    "group": "wands",
    "asset": "tarot-wands-12-knight.webp",
    "upright": [
      "energy",
      "initiative",
      "pursuit",
      "momentum"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "haste",
      "stalled effort"
    ]
  },
  {
    "id": "wands-13-queen",
    "name": "Queen of Wands",
    "group": "wands",
    "asset": "tarot-wands-13-queen.webp",
    "upright": [
      "energy",
      "initiative",
      "discernment",
      "mature care"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "insecurity",
      "overextension"
    ]
  },
  {
    "id": "wands-14-king",
    "name": "King of Wands",
    "group": "wands",
    "asset": "tarot-wands-14-king.webp",
    "upright": [
      "energy",
      "initiative",
      "leadership",
      "mastery"
    ],
    "reversed": [
      "delay",
      "scattered energy",
      "control",
      "poor judgement"
    ]
  },
  {
    "id": "cups-01-ace",
    "name": "Ace of Cups",
    "group": "cups",
    "asset": "tarot-cups-01-ace.webp",
    "upright": [
      "emotion",
      "relationship",
      "new opening",
      "potential"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "blocked start",
      "missed opening"
    ]
  },
  {
    "id": "cups-02-two",
    "name": "Two of Cups",
    "group": "cups",
    "asset": "tarot-cups-02-two.webp",
    "upright": [
      "emotion",
      "relationship",
      "choice",
      "balance"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "indecision",
      "imbalance"
    ]
  },
  {
    "id": "cups-03-three",
    "name": "Three of Cups",
    "group": "cups",
    "asset": "tarot-cups-03-three.webp",
    "upright": [
      "emotion",
      "relationship",
      "growth",
      "collaboration"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "misalignment",
      "tension"
    ]
  },
  {
    "id": "cups-04-four",
    "name": "Four of Cups",
    "group": "cups",
    "asset": "tarot-cups-04-four.webp",
    "upright": [
      "emotion",
      "relationship",
      "structure",
      "consolidation"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "stagnation",
      "rigidity"
    ]
  },
  {
    "id": "cups-05-five",
    "name": "Five of Cups",
    "group": "cups",
    "asset": "tarot-cups-05-five.webp",
    "upright": [
      "emotion",
      "relationship",
      "challenge",
      "necessary change"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "recovery",
      "lingering strain"
    ]
  },
  {
    "id": "cups-06-six",
    "name": "Six of Cups",
    "group": "cups",
    "asset": "tarot-cups-06-six.webp",
    "upright": [
      "emotion",
      "relationship",
      "support",
      "adjustment"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "unequal exchange",
      "unresolved past"
    ]
  },
  {
    "id": "cups-07-seven",
    "name": "Seven of Cups",
    "group": "cups",
    "asset": "tarot-cups-07-seven.webp",
    "upright": [
      "emotion",
      "relationship",
      "assessment",
      "strategy"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "doubt",
      "unhelpful shortcut"
    ]
  },
  {
    "id": "cups-08-eight",
    "name": "Eight of Cups",
    "group": "cups",
    "asset": "tarot-cups-08-eight.webp",
    "upright": [
      "emotion",
      "relationship",
      "movement",
      "developing mastery"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "restriction",
      "delay"
    ]
  },
  {
    "id": "cups-09-nine",
    "name": "Nine of Cups",
    "group": "cups",
    "asset": "tarot-cups-09-nine.webp",
    "upright": [
      "emotion",
      "relationship",
      "attainment",
      "inner state"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "anxiety",
      "isolation"
    ]
  },
  {
    "id": "cups-10-ten",
    "name": "Ten of Cups",
    "group": "cups",
    "asset": "tarot-cups-10-ten.webp",
    "upright": [
      "emotion",
      "relationship",
      "completion",
      "consequence"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "burden",
      "unfinished cycle"
    ]
  },
  {
    "id": "cups-11-page",
    "name": "Page of Cups",
    "group": "cups",
    "asset": "tarot-cups-11-page.webp",
    "upright": [
      "emotion",
      "relationship",
      "curiosity",
      "new message"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "immaturity",
      "mixed signal"
    ]
  },
  {
    "id": "cups-12-knight",
    "name": "Knight of Cups",
    "group": "cups",
    "asset": "tarot-cups-12-knight.webp",
    "upright": [
      "emotion",
      "relationship",
      "pursuit",
      "momentum"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "haste",
      "stalled effort"
    ]
  },
  {
    "id": "cups-13-queen",
    "name": "Queen of Cups",
    "group": "cups",
    "asset": "tarot-cups-13-queen.webp",
    "upright": [
      "emotion",
      "relationship",
      "discernment",
      "mature care"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "insecurity",
      "overextension"
    ]
  },
  {
    "id": "cups-14-king",
    "name": "King of Cups",
    "group": "cups",
    "asset": "tarot-cups-14-king.webp",
    "upright": [
      "emotion",
      "relationship",
      "leadership",
      "mastery"
    ],
    "reversed": [
      "emotional block",
      "disconnection",
      "control",
      "poor judgement"
    ]
  },
  {
    "id": "swords-01-ace",
    "name": "Ace of Swords",
    "group": "swords",
    "asset": "tarot-swords-01-ace.webp",
    "upright": [
      "thought",
      "truth",
      "new opening",
      "potential"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "blocked start",
      "missed opening"
    ]
  },
  {
    "id": "swords-02-two",
    "name": "Two of Swords",
    "group": "swords",
    "asset": "tarot-swords-02-two.webp",
    "upright": [
      "thought",
      "truth",
      "choice",
      "balance"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "indecision",
      "imbalance"
    ]
  },
  {
    "id": "swords-03-three",
    "name": "Three of Swords",
    "group": "swords",
    "asset": "tarot-swords-03-three.webp",
    "upright": [
      "thought",
      "truth",
      "growth",
      "collaboration"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "misalignment",
      "tension"
    ]
  },
  {
    "id": "swords-04-four",
    "name": "Four of Swords",
    "group": "swords",
    "asset": "tarot-swords-04-four.webp",
    "upright": [
      "thought",
      "truth",
      "structure",
      "consolidation"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "stagnation",
      "rigidity"
    ]
  },
  {
    "id": "swords-05-five",
    "name": "Five of Swords",
    "group": "swords",
    "asset": "tarot-swords-05-five.webp",
    "upright": [
      "thought",
      "truth",
      "challenge",
      "necessary change"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "recovery",
      "lingering strain"
    ]
  },
  {
    "id": "swords-06-six",
    "name": "Six of Swords",
    "group": "swords",
    "asset": "tarot-swords-06-six.webp",
    "upright": [
      "thought",
      "truth",
      "support",
      "adjustment"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "unequal exchange",
      "unresolved past"
    ]
  },
  {
    "id": "swords-07-seven",
    "name": "Seven of Swords",
    "group": "swords",
    "asset": "tarot-swords-07-seven.webp",
    "upright": [
      "thought",
      "truth",
      "assessment",
      "strategy"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "doubt",
      "unhelpful shortcut"
    ]
  },
  {
    "id": "swords-08-eight",
    "name": "Eight of Swords",
    "group": "swords",
    "asset": "tarot-swords-08-eight.webp",
    "upright": [
      "thought",
      "truth",
      "movement",
      "developing mastery"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "restriction",
      "delay"
    ]
  },
  {
    "id": "swords-09-nine",
    "name": "Nine of Swords",
    "group": "swords",
    "asset": "tarot-swords-09-nine.webp",
    "upright": [
      "thought",
      "truth",
      "attainment",
      "inner state"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "anxiety",
      "isolation"
    ]
  },
  {
    "id": "swords-10-ten",
    "name": "Ten of Swords",
    "group": "swords",
    "asset": "tarot-swords-10-ten.webp",
    "upright": [
      "thought",
      "truth",
      "completion",
      "consequence"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "burden",
      "unfinished cycle"
    ]
  },
  {
    "id": "swords-11-page",
    "name": "Page of Swords",
    "group": "swords",
    "asset": "tarot-swords-11-page.webp",
    "upright": [
      "thought",
      "truth",
      "curiosity",
      "new message"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "immaturity",
      "mixed signal"
    ]
  },
  {
    "id": "swords-12-knight",
    "name": "Knight of Swords",
    "group": "swords",
    "asset": "tarot-swords-12-knight.webp",
    "upright": [
      "thought",
      "truth",
      "pursuit",
      "momentum"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "haste",
      "stalled effort"
    ]
  },
  {
    "id": "swords-13-queen",
    "name": "Queen of Swords",
    "group": "swords",
    "asset": "tarot-swords-13-queen.webp",
    "upright": [
      "thought",
      "truth",
      "discernment",
      "mature care"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "insecurity",
      "overextension"
    ]
  },
  {
    "id": "swords-14-king",
    "name": "King of Swords",
    "group": "swords",
    "asset": "tarot-swords-14-king.webp",
    "upright": [
      "thought",
      "truth",
      "leadership",
      "mastery"
    ],
    "reversed": [
      "confusion",
      "avoidance",
      "control",
      "poor judgement"
    ]
  },
  {
    "id": "pentacles-01-ace",
    "name": "Ace of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-01-ace.webp",
    "upright": [
      "resources",
      "stability",
      "new opening",
      "potential"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "blocked start",
      "missed opening"
    ]
  },
  {
    "id": "pentacles-02-two",
    "name": "Two of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-02-two.webp",
    "upright": [
      "resources",
      "stability",
      "choice",
      "balance"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "indecision",
      "imbalance"
    ]
  },
  {
    "id": "pentacles-03-three",
    "name": "Three of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-03-three.webp",
    "upright": [
      "resources",
      "stability",
      "growth",
      "collaboration"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "misalignment",
      "tension"
    ]
  },
  {
    "id": "pentacles-04-four",
    "name": "Four of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-04-four.webp",
    "upright": [
      "resources",
      "stability",
      "structure",
      "consolidation"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "stagnation",
      "rigidity"
    ]
  },
  {
    "id": "pentacles-05-five",
    "name": "Five of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-05-five.webp",
    "upright": [
      "resources",
      "stability",
      "challenge",
      "necessary change"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "recovery",
      "lingering strain"
    ]
  },
  {
    "id": "pentacles-06-six",
    "name": "Six of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-06-six.webp",
    "upright": [
      "resources",
      "stability",
      "support",
      "adjustment"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "unequal exchange",
      "unresolved past"
    ]
  },
  {
    "id": "pentacles-07-seven",
    "name": "Seven of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-07-seven.webp",
    "upright": [
      "resources",
      "stability",
      "assessment",
      "strategy"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "doubt",
      "unhelpful shortcut"
    ]
  },
  {
    "id": "pentacles-08-eight",
    "name": "Eight of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-08-eight.webp",
    "upright": [
      "resources",
      "stability",
      "movement",
      "developing mastery"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "restriction",
      "delay"
    ]
  },
  {
    "id": "pentacles-09-nine",
    "name": "Nine of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-09-nine.webp",
    "upright": [
      "resources",
      "stability",
      "attainment",
      "inner state"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "anxiety",
      "isolation"
    ]
  },
  {
    "id": "pentacles-10-ten",
    "name": "Ten of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-10-ten.webp",
    "upright": [
      "resources",
      "stability",
      "completion",
      "consequence"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "burden",
      "unfinished cycle"
    ]
  },
  {
    "id": "pentacles-11-page",
    "name": "Page of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-11-page.webp",
    "upright": [
      "resources",
      "stability",
      "curiosity",
      "new message"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "immaturity",
      "mixed signal"
    ]
  },
  {
    "id": "pentacles-12-knight",
    "name": "Knight of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-12-knight.webp",
    "upright": [
      "resources",
      "stability",
      "pursuit",
      "momentum"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "haste",
      "stalled effort"
    ]
  },
  {
    "id": "pentacles-13-queen",
    "name": "Queen of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-13-queen.webp",
    "upright": [
      "resources",
      "stability",
      "discernment",
      "mature care"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "insecurity",
      "overextension"
    ]
  },
  {
    "id": "pentacles-14-king",
    "name": "King of Pentacles",
    "group": "pentacles",
    "asset": "tarot-pentacles-14-king.webp",
    "upright": [
      "resources",
      "stability",
      "leadership",
      "mastery"
    ],
    "reversed": [
      "instability",
      "misplaced priority",
      "control",
      "poor judgement"
    ]
  }
].map((card) => Object.freeze(card)));

export const THEME_DEFINITIONS = Object.freeze([
  {
    "id": "love",
    "label": "Love",
    "cardId": "major-06-the-lovers",
    "tone": "Romance · Relationship · Attraction",
    "prompts": [
      "What do I need to understand about this relationship?",
      "What pattern is shaping my love life right now?",
      "What would help me move forward with clarity?"
    ]
  },
  {
    "id": "career",
    "label": "Career",
    "cardId": "major-01-the-magician",
    "tone": "Ability · Opportunity · Action",
    "prompts": [
      "What should I focus on to grow in my career?",
      "What opportunity am I not seeing clearly?",
      "What is blocking my next professional step?"
    ]
  },
  {
    "id": "wealth",
    "label": "Wealth",
    "cardId": "pentacles-01-ace",
    "tone": "Money · Opportunity · Practical reality",
    "prompts": [
      "What is shaping my financial situation right now?",
      "What practical habit or decision could improve my stability?",
      "Where is the next realistic opportunity for growth?"
    ]
  },
  {
    "id": "personal-growth",
    "label": "Personal Growth",
    "cardId": "major-09-the-hermit",
    "tone": "Exploration · Self-reflection · Growth",
    "prompts": [
      "What pattern am I ready to outgrow?",
      "What inner strength should I develop now?",
      "What lesson is this chapter asking me to learn?"
    ]
  },
  {
    "id": "spiritual-guidance",
    "label": "Spiritual Guidance",
    "cardId": "major-02-the-high-priestess",
    "tone": "Mystery · Intuition · Inspiration",
    "prompts": [
      "What is my intuition trying to show me?",
      "What should I pay closer attention to right now?",
      "How can I reconnect with my inner guidance?"
    ]
  },
  {
    "id": "general-outlook",
    "label": "General Outlook",
    "cardId": "major-10-wheel-of-fortune",
    "tone": "Change · Cycles · Future direction",
    "prompts": [
      "What is the main energy shaping my next chapter?",
      "What change should I prepare for?",
      "Where should I direct my attention now?"
    ]
  },
  {
    "id": "healing",
    "label": "Healing",
    "cardId": "major-17-the-star",
    "tone": "Gentleness · Restoration · Hope",
    "prompts": [
      "What needs gentle attention right now?",
      "What would support my emotional healing?",
      "What am I ready to release?"
    ]
  }
].map((theme) => Object.freeze({ ...theme, prompts: Object.freeze(theme.prompts) })));

export const DRAW_POSITIONS = Object.freeze(['Situation', 'Challenge', 'Advice']);
